<template>
    <div class="content-wrapper">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a href="#">
                        <i class="fa fa-home"></i>
                        Dashboard
                    </a>
                </li>
                <li class="breadcrumb-item">
                    <a href="#">
                        <i class="fa fa-cogs"></i>
                        Configuration
                    </a>
                </li>
                <li class="breadcrumb-item active">Table</li>
            </ol>
        </nav>
        <section class="content">
            <div class="container-fluid">
                <div class="row justify-content-md-center">
                    <div class="col-sm-5">
                        <form class="card" @submit.prevent="submitForm()">
                            <div class="card-header">
                                <h3 class="card-title" v-if="status">New Table</h3>
                                <h3 class="card-title" v-else>Update Table</h3>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="table">Table *</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.table}" placeholder="Table" v-model="table.table" />
                                            <span v-if="errors.table" class="invalid-feedback">{{ errors.table[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="amount">Stack *</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.amount}" placeholder="Stack" v-model="table.amount" />
                                            <span v-if="errors.amount" class="invalid-feedback">{{ errors.amount[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="play_time">Play Time *</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.play_time}" placeholder="Play Time" v-model="table.play_time" />
                                            <span v-if="errors.play_time" class="invalid-feedback">{{ errors.play_time[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="call_time">Call Time *</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.call_time}" placeholder="Call Time" v-model="table.call_time" />
                                            <span v-if="errors.call_time" class="invalid-feedback">{{ errors.call_time[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="buffer_call_time">Buffer Call Time *</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.buffer_call_time}" placeholder="Buffer Call Time" v-model="table.buffer_call_time" />
                                            <span v-if="errors.buffer_call_time" class="invalid-feedback">{{ errors.buffer_call_time[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="small_blind">Small Blind *</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.small_blind}" placeholder="Small Blind" v-model="table.small_blind" />
                                            <span v-if="errors.small_blind" class="invalid-feedback">{{ errors.small_blind[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="big_blind">Big Blind *</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.big_blind}" placeholder="Big Blind" v-model="table.big_blind" />
                                            <span v-if="errors.big_blind" class="invalid-feedback">{{ errors.big_blind[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="stradle">Stradle</label>
                                            <input type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.stradle}" placeholder="Stradle" v-model="table.stradle" />
                                            <span v-if="errors.stradle" class="invalid-feedback">{{ errors.stradle[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label for="description">Description</label>
                                            <textarea type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.description}" placeholder="Description" v-model="table.description"></textarea>
                                            <span v-if="errors.description" class="invalid-feedback">{{ errors.description[0] }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="float-right">
                                    <button class="btn btn-sm btn-outline-danger" type="button" @click="discard()"><i class="fas fa-ban"></i> Discard</button>
                                    <button class="btn btn-sm btn-outline-success" type="submit">
                                        <span v-if="status"> <i class="fas fa-save"></i> Submit </span>
                                        <span v-else> <i class="fas fa-save"></i> Update </span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-sm-7">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Tables</h3>
                                <div class="card-tools">
                                    <div class="custom-control custom-switch custom-switch-off-success custom-switch-on-danger">
                                        <input type="checkbox" class="custom-control-input" id="trashed" v-model="meta.trashed" @click="isTrashed" />
                                        <label class="custom-control-label" for="trashed">Trashed</label>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <input class="form-control form-control-sm" type="text" placeholder="Search" v-model="meta.search" @keyup="search"  v-if="!meta.trashed"/>
                                </div>
                                <table class="table table-responsive-sm table-bordered table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th @click="sort('table')">Table
                                                <span>
                                                    <i v-if="meta.keyword=='table' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='table' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('amount')" class="text-center">Stack
                                                <span>
                                                    <i v-if="meta.keyword=='amount' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='amount' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('play_time')" class="text-center">Play Time
                                                <span>
                                                    <i v-if="meta.keyword=='play_time' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='play_time' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('call_time')" class="text-center">Call Time
                                                <span>
                                                    <i v-if="meta.keyword=='call_time' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='call_time' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th class="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(table,key) in tables" :key="key">
                                            <td class="text-center">{{meta.from+key}}</td>
                                            <td>{{table.table}}</td>
                                            <td class="text-center">{{table.amount}}</td>
                                            <td class="text-center">{{table.play_time}}</td>
                                            <td class="text-center">{{table.call_time}}</td>
                                            <td class="text-center" v-if="!meta.trashed">
                                                <button class="btn btn-xs btn-outline-success" data-toggle="tooltip" data-placement="bottom" title="Edit">
                                                    <i class="fas fa-pencil-alt" @click="edit(table)"></i>
                                                </button>
                                                <button class="btn btn-xs btn-outline-danger" data-toggle="tooltip" data-placement="bottom" title="Delete" @click="deleteTable(table)">
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </td>
                                            <td class="text-center" v-else>
                                                <button class="btn btn-xs btn-outline-success" data-toggle="tooltip" data-placement="bottom" title="Restore" @click="deleteTable(table)">
                                                    <i class="fas fa-trash-restore"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="tables.length <= 0">
                                            <td colspan="20" style="text-align: center;">No Records Found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer">
                                <div class="float-right">
                                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        name: "Table",
        components: { Pagination },
        data() {
            return {
                status: true,
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "table",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                    trashed: false,
                    branch_id : this.$store.getters.user.branch_id
                },
                table: {
                    table_id: "",
                    table: "",
                    branch_id: "",
                    description: "",
                    amount:"",
                    play_time:"",
                    call_time:"",
                    buffer_call_time:"",
                    small_blind:"",
                    big_blind:"",
                    stradle:""
                },
                tables: [],
                errors: [],
            };
        },
        mounted() {
            let vm = this;
            vm.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },

            edit(table) {
                let vm = this;
                (vm.status = false), (vm.table = table), vm.$refs.table.focus();
            },


            search(){
               let vm = this;
               vm.meta.page = 1;
               vm.index();

            },

            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateTables", data: vm.meta })
                    .then(function (response) {
                        vm.tables = response.data.data;
                        console.log(vm.tables);
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            isTrashed() {
                let vm = this;
                vm.meta.trashed = !vm.meta.trashed;
                if(vm.meta.trashed)
                    vm.meta.page = 1
                vm.index();
            },

            
            create() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.table.branch_id = vm.$store.getters.user.branch_id;
                let uri = { uri: "addTable", data: vm.table };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Table is successfully created");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            discard() {
                let vm = this;
                vm.table.table = "";
                vm.table.description = "";
                vm.errors = [];
                vm.status = true;
                vm.index();
            },

            update() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "updateTable", data: vm.table };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Table is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            deleteTable(table) {
                if (confirm("Do you want to continue... ?")) {
                    let vm = this;
                    let loader = vm.$loading.show();
                    let uri = { uri: "deleteTable", data: table };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function () {
                            loader.hide();
                            vm.$store.dispatch("success", "Table is successfully deleted");
                            vm.discard();
                        })
                        .catch(function (error) {
                            loader.hide();
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by=='asc' ? 'desc' : 'asc';
                this.index();
            },
        },
    };
</script>

